var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9846 31.1961L36.6133 32.2659L64.6081 52.415L59.972 57.4077L57.8323 55.9813L47.8469 65.9667L21.9919 56.3379L15.751 45.4609L26.9846 31.1961Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1018 30.996L66.5871 52.2179L60.174 59.1242L57.9999 57.6747L48.1797 67.495L21.0868 57.4053L14.167 45.3449L26.4029 29.8073L37.1018 30.996ZM17.3347 45.5768L22.8966 55.2705L47.5138 64.4382L57.6645 54.2877L59.7698 55.6911L62.6289 52.6121L36.1245 33.5357L27.566 32.5848L17.3347 45.5768Z",
    fill: "#18181B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6042 58.4834L53.1841 60.6997L48.3848 57.6243L49.8049 55.4081L54.6042 58.4834Z",
    fill: "#18181B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7263 56.3295L59.2169 58.4859L52.0845 53.4932L53.5939 51.3368L60.7263 56.3295Z",
    fill: "#18181B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4903 40.0837L43.5674 41.1815V45.2826L35.5435 41.3598L41.4277 28.878L53.7312 30.3045L60.8636 28.878L72.0972 39.9333L63.0033 51.1669L47.4903 40.0837Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8713 39.8331L63.2462 52.9581L47.2376 41.521L44.8832 42.1798V47.391L33.7993 41.9722L40.6399 27.4618L53.6761 28.9732L61.2892 27.4507L73.8713 39.8331ZM37.2869 40.7473L42.251 43.1742V40.183L47.7422 38.6465L62.7597 49.3756L70.3223 40.0336L60.4372 30.3054L53.7853 31.6358L42.2147 30.2942L37.2869 40.7473Z",
    fill: "#18181B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9404 25.8467L74.7257 42.3186L82.4389 31.2676L66.6478 17.0667L56.9404 25.8467Z",
    fill: "#93C5FD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.184 31.0669L74.9401 44.311L54.9912 25.8352L66.6454 15.2944L84.184 31.0669ZM58.8898 25.8582L74.5113 40.326L80.6938 31.4683L66.6504 18.8389L58.8898 25.8582Z",
    fill: "#18181B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2585 27.3136C65.1931 27.3136 65.9507 26.556 65.9507 25.6214C65.9507 24.6869 65.1931 23.9293 64.2585 23.9293C63.324 23.9293 62.5664 24.6869 62.5664 25.6214C62.5664 26.556 63.324 27.3136 64.2585 27.3136Z",
    fill: "#18181B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6973 56.55L43.7454 69.7112L47.1333 59.7258L43.0321 57.2294L44.4586 53.8415L31.6202 46.5308L22.6973 56.55Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1253 53.2758L44.6856 56.6948L48.7189 59.1499L44.4578 71.7087L20.6777 56.8392L31.3462 44.86L46.1253 53.2758ZM24.7176 56.2608L43.0337 67.7137L45.5485 60.3016L41.3794 57.7639L42.7928 54.4072L31.895 48.2016L24.7176 56.2608Z",
    fill: "#18181B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2515 55.3499L40.1422 67.373L37.7197 66.3435L42.8289 54.3204L45.2515 55.3499Z",
    fill: "#18181B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2179 49.2736L28.4409 60.638L26.2686 59.1514L34.0457 47.7871L36.2179 49.2736Z",
    fill: "#18181B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.009 51.8248L34.5468 64.1437L32.2158 62.921L38.6781 50.602L41.009 51.8248Z",
    fill: "#18181B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2544 48.4922L30.7289 27.2732L21.2784 20.1408L4.33887 40.6465L13.2544 48.4922Z",
    fill: "#18181B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6176 27.0499L13.4058 50.3786L2.51172 40.7918L21.0658 18.3315L32.6176 27.0499ZM6.16588 40.5012L13.1029 46.6058L28.8399 27.4965L21.4908 21.95L6.16588 40.5012Z",
    fill: "#18181B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9456 27.9716C23.0878 27.9716 24.0138 27.0457 24.0138 25.9035C24.0138 24.7612 23.0878 23.8353 21.9456 23.8353C20.8034 23.8353 19.8774 24.7612 19.8774 25.9035C19.8774 27.0457 20.8034 27.9716 21.9456 27.9716Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultIcon);
export default __webpack_public_path__ + "static/media/resultIcon.415b4e23585f0002eda83923aefcae9c.svg";
export { ForwardRef as ReactComponent };